<div>
    <app-custom-header></app-custom-header>
    <div class="margin-responsive">
        <router-outlet></router-outlet>
    </div>
</div>
<ek-toast position="bottom-left" />
